import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../../hooks/store-hooks";
import { Autocomplete, Grid, TextField } from "@mui/material";
import { useListaCboService } from "../../../../../../../use-cases/geo-veles/lista-cbo";
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles";
import { IListaCbo } from "../../../../../../../application/models/geo-veles/IListaCbo";

export const RecorteListasCboFilterEdit = () => {
  const { listasCbo } = useAppSelector((state) => state.listaCbo);
  const { editRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao);

  const [selectedListasCbo, setSelectedListasCbo] = useState<IListaCbo[]>([]);

  const { setupListasCbo } = useListaCboService();
  const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService();

  useEffect(() => {
    const listasSelecionadasIds = editRecorteExtracaoForm.fields.Filtros?.listasCbo || [];

    if (listasSelecionadasIds.length > 0) {
      const listasCompletas = listasCbo.filter(lista =>
        listasSelecionadasIds.includes(lista.IdVelesGeoListaCBO)
      );
      setSelectedListasCbo(listasCompletas);
    } else {
      setSelectedListasCbo([]);
    }
  }, [editRecorteExtracaoForm.fields.Filtros?.listasCbo, listasCbo]);

  // Filter options to show only non-selected lists
  const filteredListasCbo = listasCbo.filter((lista) =>
    !selectedListasCbo.some(selected => selected.IdVelesGeoListaCBO === lista.IdVelesGeoListaCBO)
  );



  const handleListasCboSelectionChange = (value: IListaCbo[]) => {
    setSelectedListasCbo(value);

    if (value.length > 0) {
      syncFilterWithForm({
        filtro: "listasCbo",
        value: value.map((lista) => lista.IdVelesGeoListaCBO),
        formType: 'edit'
      });
    } else {
      removeFilterFromForm({
        filtro: "listasCbo",
        formType: 'edit'
      });
    }
  };

  useEffect(() => {
    setupListasCbo();
  }, [setupListasCbo]);

  return (
    <>
      <Grid item xs={11} my={2}>
        <Autocomplete
          multiple
          id="listas-cbo-autocomplete"
          options={filteredListasCbo}
          getOptionLabel={(option) => option.Nome?.toUpperCase() || ""}
          isOptionEqualToValue={(option, value) =>
            option.IdVelesGeoListaCBO === value.IdVelesGeoListaCBO
          }
          value={selectedListasCbo}
          onChange={(_, value) => {
            handleListasCboSelectionChange(value);
          }}
          noOptionsText="Nenhuma lista de CBO encontrada"
          filterSelectedOptions={true}
          disableCloseOnSelect
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Listas de CBO"
            />
          )}
          sx={{ px: 2 }}
        />
      </Grid>
    </>
  );
};